export class ArrayUtils {

    public static divideArray(array: Array<any>, size): Array<Array<any>> {

        var startIndex = 0;
        var arraySize = size;
        var endIndex = arraySize;
        var arrays = [];

        while (true) {
            arrays.push(array.slice(startIndex, endIndex));
            startIndex = endIndex;
            if (endIndex >= array.length) {
                break;
            }
            endIndex += arraySize;
        }

        return arrays;
    }
}


// WEBPACK FOOTER //
// ./src/app/utilities/ArrayUtils/ArrayUtils.ts